export default "__VITE_ASSET__2864fa84__"